<footer>
    <div class="row py-5" style="background-color: #26292e; padding-left: 10%; padding-right: 10%;">
        <div class="col-md-6">
            <div class="mb-3">
                <img src="assets/logo_mp_blanco.png" alt="Logo MP" class="img-fluid">
            </div>
            <div>
                <img src="assets/logo-itp-blanco.png" alt="Logo ITP" class="img-fluid">
            </div>
        </div>


        <div class="col-md-6">
            <h5 class="pb-3">Datos de la Entidad</h5>
            <div class="ps-4">
                <p>Sede central: Av. República de Panamá 3418 - San Isidro - Lima - Lima - Perú</p>
                <p>Central telefónica: (01) 680-2150</p>
                <p>Horario de atención: Lunes a viernes, 8:00 – 17:00</p>

                <div class="contact-section pt">
                    <h5 style="margin: 0;">Contáctenos</h5>
                    <div class="social-icons">
                        <a href="https://www.facebook.com/ITPProduccion" target="_blank">
                            <img src="assets/redes-sociales/facebook-bn.png" alt="Facebook">
                        </a>
                        <a href="https://x.com/ITPproduccion" target="_blank">
                            <img src="assets/redes-sociales/x-bn.png" alt="Twitter">
                        </a>
                        <a href="https://www.instagram.com/itpproduccion/" target="_blank">
                            <img src="assets/redes-sociales/instagram-bn.png" alt="Instagram">
                        </a>
                        <a href="https://www.youtube.com/@ITPproduccion" target="_blank">
                            <img src="assets/redes-sociales/youtube-bn.png" alt="YouTube">
                        </a>
                    </div>
                </div>
            </div>


        </div>

    </div>

    <div class="row py-4" style="background-color: #b72727; padding-left: 10%; padding-right: 10%;">
        <div class="col-12">
            <p style="color: white; margin: 0;">© Instituto Tecnológico de la Producción - ITP 2026</p>
        </div>
    </div>
</footer>